import { lazy } from 'react';

// The cabinet's pages, each loaded when its route is first visited, so a visitor to the public
// site does not download the cabinet. Named exports, hence the `.then` to a default.
export const CabinetPage = lazy(() =>
  import('@/features/cabinet/CabinetPage').then((m) => ({ default: m.CabinetPage })),
);
export const ProfilePage = lazy(() =>
  import('@/features/cabinet/ProfilePage').then((m) => ({ default: m.ProfilePage })),
);
export const EditProfilePage = lazy(() =>
  import('@/features/cabinet/EditProfilePage').then((m) => ({ default: m.EditProfilePage })),
);
export const NotificationSettingsPage = lazy(() =>
  import('@/features/cabinet/NotificationSettingsPage').then((m) => ({
    default: m.NotificationSettingsPage,
  })),
);
export const SavedLibraryPage = lazy(() =>
  import('@/features/library/SavedLibraryPage').then((m) => ({ default: m.SavedLibraryPage })),
);
export const ApplicationsPage = lazy(() =>
  import('@/features/cabinet/ApplicationsPage').then((m) => ({ default: m.ApplicationsPage })),
);
export const EventDraftEditPage = lazy(() =>
  import('@/features/cabinet/EventDraftEditPage').then((m) => ({ default: m.EventDraftEditPage })),
);
export const DossierDetailPage = lazy(() =>
  import('@/features/cabinet/DossierDetailPage').then((m) => ({ default: m.DossierDetailPage })),
);
export const PublicationsPage = lazy(() =>
  import('@/features/cabinet/PublicationsPage').then((m) => ({ default: m.PublicationsPage })),
);
export const ApplyFundingPage = lazy(() =>
  import('@/features/funding/ApplyFundingPage').then((m) => ({ default: m.ApplyFundingPage })),
);
export const ApplicationsRegisterPage = lazy(() =>
  import('@/features/funding/ApplicationsRegisterPage').then((m) => ({
    default: m.ApplicationsRegisterPage,
  })),
);
export const RegisterOrganizationPage = lazy(() =>
  import('@/features/research/RegisterOrganizationPage').then((m) => ({
    default: m.RegisterOrganizationPage,
  })),
);
export const AdoptionsPage = lazy(() =>
  import('@/features/research/AdoptionsPage').then((m) => ({ default: m.AdoptionsPage })),
);
export const ResearchOrganizationPage = lazy(() =>
  import('@/features/research/ResearchOrganizationPage').then((m) => ({
    default: m.ResearchOrganizationPage,
  })),
);
export const AdvisorProfilePage = lazy(() =>
  import('@/features/advisors/AdvisorProfilePage').then((m) => ({ default: m.AdvisorProfilePage })),
);
export const ProviderPage = lazy(() =>
  import('@/features/services/ProviderPage').then((m) => ({ default: m.ProviderPage })),
);
export const MyTrainingsPage = lazy(() =>
  import('@/features/training/MyTrainingsPage').then((m) => ({ default: m.MyTrainingsPage })),
);
export const EventAdminPage = lazy(() =>
  import('@/features/events/EventAdminPage').then((m) => ({ default: m.EventAdminPage })),
);
export const MyEventsPage = lazy(() =>
  import('@/features/events/MyEventsPage').then((m) => ({ default: m.MyEventsPage })),
);
export const TrainingAdminPage = lazy(() =>
  import('@/features/training/TrainingAdminPage').then((m) => ({ default: m.TrainingAdminPage })),
);
export const MyTrainingInstitutionPage = lazy(() =>
  import('@/features/training/MyTrainingInstitutionPage').then((m) => ({
    default: m.MyTrainingInstitutionPage,
  })),
);
export const MyCommunityPage = lazy(() =>
  import('@/features/community/MyCommunityPage').then((m) => ({ default: m.MyCommunityPage })),
);
export const EventEvaluationAnalysisPage = lazy(() =>
  import('@/features/eventEvaluations/EventEvaluationAnalysisPage').then((m) => ({
    default: m.EventEvaluationAnalysisPage,
  })),
);
